Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = void 0;
const shared = require("@volar/shared");
const selectionRange_1 = require("./selectionRange");
function transform(locations, getOtherRange) {
    return locations
        .map(location => (0, selectionRange_1.transform)(location, getOtherRange))
        .filter(shared.notEmpty);
}
exports.transform = transform;
//# sourceMappingURL=selectionRanges.js.map